import { ButtonWrapper } from "./styles";
import { ButtonProps } from "antd";
export type ButtonVariant = "primary" | "danger" | "warning";

type IProps = ButtonProps & {
  variant?: ButtonVariant;
  directionRadius?: "up" | "down" | "left" | "right" | "none";
};
const ButtonVertical = ({
  variant = "primary",
  directionRadius = "left",
  ...restProps
}: IProps) => {
  const radiusMap = {
    left: "4px 0 0 4px",
    right: "0 4px 4px 0",
    up: "4px 4px 0 0",
    down: "0 0 4px 4px",
    none: "0px",
  };
  return (
    <ButtonWrapper
      {...restProps}
      $variant={variant}
      $borderRadius={radiusMap[directionRadius]}
    />
  );
};

export default ButtonVertical;
